import i18n from 'i18next';

import { feverErrCodes, highTrafficErrCodes } from 'client/utils/errorObjectChecker';

export const handlers = {
    CLOSE: 'close',
    RELOAD: 'reload',
    LOGOUT_RELOAD: 'logoutReload',
    HIDE_BUTTON: 'hideButton',
    TRY_AGAIN: 'tryAgain',
    PASSCODE_UNVERIFIED: 'passcodeUnverified',
    PASSCODE_DENIED: 'passcodeDenied',
    GOTO_MASTER_PROMO: 'gotoMasterPromo'
};

export const SHOW_SYSTEM_ERROR = 'systemErrorDialog/show_system_error';
const CLOSE_SYSTEM_ERROR = 'systemErrorDialog/close_system_error';

const defaultState = {
    persist: false,
    show: false,
    title: '',
    desc: '',
    handler: '',
    buttonText: ''
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SHOW_SYSTEM_ERROR:
            return { ...state, show: true, ...(action.payload ?? {}) };
        case CLOSE_SYSTEM_ERROR:
            return state.persist === true
                ? { ...state, show: false }
                : { ...state, ...(action.payload ?? {}) };
        default:
            return state;
    }
};

export default reducer;

export function showErrDialog() {
    return {
        type: SHOW_SYSTEM_ERROR
    };
}

export function closeSystemErrorDialog() {
    return {
        type: CLOSE_SYSTEM_ERROR,
        payload: defaultState
    };
}

/**
 * @param {string} [buttonText] 目前只有 `handlers.CLOSE` 會用；不給就是「關閉」
 */
export function showCustomErrDialog({
    title,
    desc,
    handler = handlers.CLOSE,
    persist = false,
    buttonText = ''
} = {}) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            persist,
            title,
            desc,
            handler,
            buttonText
        }
    };
}

export function showGeneralErrorDialog({
    title = i18n.t('label.system.error'),
    serial,
    code,
    handler = handlers.RELOAD
} = {}) {
    const desc = `
        ${Boolean(serial) ? `${i18n.t('label.error_serial_no')}: ${serial}\n` : ''}${
        Boolean(code) ? `${i18n.t('label.error_code')}: ${code}` : i18n.t('label.try_again_later')
    }
    `.trim();

    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title,
            desc,
            handler
        }
    };
}

export function showGetPromoDataErrorDialog(code, eventId) {
    return showGeneralErrorDialog({
        title: highTrafficErrCodes.has(code)
            ? i18n.t('label.system.high_traffic')
            : i18n.t('label.system.busy'),
        code: Boolean(eventId) ? `${eventId} ( ${code} )` : code,
        handler: highTrafficErrCodes.has(code) ? handlers.TRY_AGAIN : handlers.RELOAD
    });
}

export function showPromoNotFoundDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.promo_not_found'),
            desc: i18n.t('desc.promo_not_found'),
            handler: handlers.HIDE_BUTTON
        }
    };
}

export function showGetPromoDataErrorAndNoRefreshBtnDialog(code) {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.busy'),
        code,
        handler: code === handlers.HIDE_BUTTON
    });
}

export function showDuplicateGetWinnerErrDialog({ code, serial }) {
    return showGeneralErrorDialog({ title: i18n.t('label.system.busy'), code, serial });
}

export function showUnauthorizedError() {
    return showGeneralErrorDialog();
}

export function showNetworkErrorDialog() {
    return showGeneralErrorDialog();
}

export function showPromoUnavailableCloseDialog() {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.unavailable'),
        handler: handlers.CLOSE
    });
}

export function showPromoNotAvailableErrDialog() {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.unavailable'),
        handler: handlers.RELOAD
    });
}

export function showPromoEndErrDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.promo_is_end'),
            desc: i18n.t('label.see_you_next_time'),
            handler: handlers.RELOAD
        }
    };
}
export function showAIFailedWithPromoEndErrDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.promo_is_end'),
            desc: i18n.t('label.ai_connection_timeout'),
            handler: handlers.RELOAD
        }
    };
}

export function showFormSubmitDuplicateErrDialog() {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.unavailable'),
        code: feverErrCodes.ERR_FORM_DUPLICATE,
        handler: handlers.RELOAD
    });
}

export function showInvalidTestCodeErrorDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.test_mode'),
            desc: i18n.t('desc.test_code_error'),
            handler: handlers.CLOSE
        }
    };
}

export function showUnfufillKKboxOrderDialog(serial) {
    const title = i18n.t('label.system.unavailable');
    const desc = `${i18n.t('label.error_serial_no')}: ${serial}\n${i18n.t(
        'desc.purchase_order_unfufill'
    )}`;

    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title,
            desc,
            handler: handlers.RELOAD
        }
    };
}

export function showContestRecalculatingCacheDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.contest_ugc.vote_rank_recalculating'),
            desc: i18n.t('label.try_again_later'),
            handler: handlers.CLOSE
        }
    };
}

export function showReloginDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            handler: handlers.LOGOUT_RELOAD
        }
    };
}

export function showTooManyAttemptErrDialog(handler = handlers.RELOAD) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.too_many_attempt'),
            desc: i18n.t('label.try_again_later'),
            handler
        }
    };
}

export function showRetryRecaptchaDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.invalid_recaptcha'),
            handler: handlers.CLOSE
        }
    };
}

// 後端回 RCPA-AU0-F0 empty：前端沒拿到 Turnstile token 就送了 create entry。
// 唯一會這樣的情況是 Turnstile 靜默失敗後的優雅降級（AppPromoClient onError → initPromo(null)），
// 阻擋來源 reload 解不掉，所以沿用 silent_fail 文案並用 CLOSE，避免 reload 循環（#86eyw7t0b）
export function showRecaptchaMissingDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('dialog.turnstile_error.silent_fail.title'),
            desc: i18n.t('dialog.turnstile_error.silent_fail.description'),
            handler: handlers.CLOSE
        }
    };
}

export function showBotProtectionFailedDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('dialog.bot_protection_failed.title'),
            desc: i18n.t('dialog.bot_protection_failed.description'),
            handler: handlers.CLOSE
        }
    };
}

// Turnstile error codes: https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/
// 102*** — Widget 與 Cloudflare 通訊失敗
// 103*** — 瀏覽器不支援所需功能
// 105*** — Turnstile API 相容性問題
// 110100 — Widget 初始化錯誤
// 300*** — 通用 client error
function getTurnstileErrorI18nKey(reason) {
    if (reason === 'silent-fail-timeout') return 'silent_fail';
    if (reason === 'timeout-callback') return 'timeout';
    if (reason === 'script-load-error') return 'network';

    // Extract numeric error code from "error-callback:XXXXXX"
    const match = reason?.match(/error-callback:(\d)/);
    const prefix = match?.[1];

    if (prefix === '1' && reason.includes('error-callback:102')) return 'network';
    if (prefix === '1' && reason.includes('error-callback:103')) return 'browser_not_supported';
    if (prefix === '1' && reason.includes('error-callback:105')) return 'browser_not_supported';
    return 'generic';
}

// reload 解不掉的情況（瀏覽器不支援、script/iframe 被擴充功能或隱私設定阻擋）
// 用 CLOSE，否則 Member 會在 reload → 同一個 dialog 之間循環（#86eyw7t0b）
const TURNSTILE_ERROR_KEYS_WITHOUT_RELOAD = new Set(['browser_not_supported', 'silent_fail']);

export function showTurnstileErrorDialog(reason) {
    const key = getTurnstileErrorI18nKey(reason);
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t(`dialog.turnstile_error.${key}.title`),
            desc: i18n.t(`dialog.turnstile_error.${key}.description`),
            handler: TURNSTILE_ERROR_KEYS_WITHOUT_RELOAD.has(key) ? handlers.CLOSE : handlers.RELOAD
        }
    };
}

export function showMergeFrameFailedDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.upload_failed'),
            desc: i18n.t('label.upload_failed.desc_composite_frame_error'),
            handler: handlers.RELOAD
        }
    };
}
export function showWinnerNotFoundDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.error.winner_not_found'),
            handler: handlers.RELOAD
        }
    };
}

export function showOpenAppAndRedeemPrizeFailDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.missing_in_app_event'),
            handler: handlers.CLOSE
        }
    };
}

export function showLiffAuthFailDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.liff_permission_denied'),
            desc: i18n.t('desc.liff_permission_denied'),
            handler: handlers.HIDE_BUTTON
        }
    };
}

export function showFillFormDuplicateDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.winner_submit_forms_duplicate'),
            desc: i18n.t('desc.winner_submit_forms_duplicate'),
            handler: handlers.RELOAD
        }
    };
}

export function showGetCheckPointCardUnexpectedDialog(uuid) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.check_point_card.unexpected'),
            desc: `${i18n.t('label.contact_customer_service')}\n${i18n.t(
                'label.check_point_card.code'
            )}: ${uuid}`,
            handler: handlers.RELOAD
        }
    };
}

export function showOpenTaskUnexpectedDialog(uuid) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.task.unexpected'),
            desc: `${i18n.t('label.contact_customer_service')}\n${i18n.t(
                'label.task.code'
            )}: ${uuid}`,
            handler: handlers.RELOAD
        }
    };
}

export function showEntryFlowExistsDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('desc.store_game_result.entry_flow_exists'),
            handler: handlers.RELOAD
        }
    };
}

// 點數鎖上鎖中
export function showPointIsLockedErrorDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('desc.point_is_locked'),
            handler: handlers.RELOAD
        }
    };
}

export function showThirdPartyApiTimedOutDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: `${i18n.t('label.err.action')} (cURL 28)`,
            handler: handlers.RELOAD
        }
    };
}

// 文字敘述後方補上錯誤代碼方便客服辨識，此類錯誤不送 Sentry
export function showSystemErrorRefreshDialog(code) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: `${i18n.t('label.err.action')}${Boolean(code) ? ` (${code})` : ''}`,
            handler: handlers.RELOAD
        }
    };
}

export function showTokenErrorDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('desc.token_error'),
            handler: handlers.RELOAD
        }
    };
}

// 人次方案額度在送出遊戲結果扣次時用盡：測試模式顯示測試上限訊息；
// 正式模式後端此時已將活動暫停，重整後會進入活動暫停頁
export function showStoreGameResultEntryTotalLimitDialog({ isTestMode = false } = {}) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: isTestMode
            ? {
                  title: i18n.t('label.test_mode'),
                  desc: i18n.t('desc.testmode_credit_full'),
                  handler: handlers.RELOAD
              }
            : {
                  title: i18n.t('label.system.unavailable'),
                  handler: handlers.RELOAD
              }
    };
}

// 當活動是 Entry 只能參加一次時，該 entry 參加過活動，但被 Admin 判定審核不通過，所以 User 達到 entry 上限，無法再建立新 entry
export function showEntryReachTotalLimitDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.verify_not_passed'),
            handler: handlers.RELOAD
        }
    };
}

export function showSequentialTaskNotUnlockedDialog(qualificationMasterPromotionUuid) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            desc: i18n.t('desc.sequential_task_not_unlocked'),
            handler: handlers.GOTO_MASTER_PROMO,
            qualificationMasterPromotionUuid
        }
    };
}

export function showOptionNotFoundDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.err_boundary.sth_went_wrong'),
            desc: i18n.t('desc.error_hint.promo_frame_not_upload'),
            handler: handlers.HIDE_BUTTON
        }
    };
}
